import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function mapObjectKey<T>() {
  return (source: Observable<T>) =>
    source.pipe(map((object: any) => (object && object.key ? { $key: object.key, ...object.payload.val() } : null)));
}
